import {
  ApplicationResultContent,
  ApplicationResultStepper,
} from '../../components/ApplicationResultContent';

const steps = [
  {
    label: 'Application submitted',
  },
  {
    label: 'Application under review',
    active: true,
    content: 'Our team will personally review your application.',
  },
  {
    label: 'Decision notification emailed',
    content:
      "We'll notify you of the decision via email, so keep an eye on your inbox! Thank you for taking the time to apply.",
  },
];

export const OrganizationApplicationUnderReview = () => {
  return (
    <ApplicationResultContent
      title="Here's an update on your application"
      description={
        <div>
          <ApplicationResultStepper steps={steps} />
        </div>
      }
    />
  );
};
